import { AccordionWithVideo } from "./accordion-with-video"

export const whyPvolve = () => {
    const initVideoAccordion = () => {
        const accordionOverviewItems = document.querySelectorAll('.overview__visual-item');
        new AccordionWithVideo({
            el: '.overview-accordion__item',
            trigger: '.overview-accordion__header',
            firstOpen: true,
            activeClass: 'is-active',
            showOne: true,
            onOpen: (_, accordionIndex) => {
               accordionOverviewItems.forEach((item) => item.classList.remove('is-active'))
                accordionOverviewItems[accordionIndex].classList.add('is-active');
            }
        })
    }

    return {
       initAccordion: initVideoAccordion
    }
}